import { EnumHelper } from "@singularsystems/neo-core";

export enum CompoundingType {
    None = 0,
    Normal = 1,
    PaidAmountOnly = 2,
}

EnumHelper.decorateEnum(CompoundingType, decorator => {
    decorator.describe(CompoundingType.None, "None", "No compounding occurs unless the dividend falls on a compounding date.");
    decorator.describe(CompoundingType.Normal, "Normal", "The accrual remaining after the dividend is added to the base capital to get the compounded balance, as with a normal compounding date.");
    decorator.describe(CompoundingType.PaidAmountOnly, "Paid amount only", "The dividend amount is subtracted from the compounded balance, but the accrual since the last compounding date is ignored.");
})